/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2021-07-01 09:57:52
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.config.productionTip = false;
import { post, get, baseURL, baseURL1, instance } from "./api/http";
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$instance = instance;
Vue.prototype.$baseURL1 = baseURL1;

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next();
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
